import React, { FC } from 'react'

import * as SC from './styled'

export type SeparatorProps = {
  className?: string
  maxWidth?: number
  height?: number
  color?: string
  isCentered?: boolean
}

const Separator: FC<SeparatorProps> = (props) => {
  const { className, maxWidth = 730, height, color, isCentered } = props

  return (
    <SC.Container>
      <SC.Bar
        className={className}
        maxWidth={maxWidth}
        height={height}
        color={color}
        isCentered={isCentered}
      />
    </SC.Container>
  )
}

export default Separator
